<template>
  <page :background-color="'#fff'" :flex="true" :columnflex="true">
    <maple-nav-bar
      v-if="!isMiniProgram"
      class="nav-bar"
      left-arrow
      title="运费规则"
      :safe-top-distance="statusBarHeight"
      @click-left="goBack"
    />
    <div class="container">
      <div
        v-for="(moduleInfo, index) in rules"
        :key="index"
        class="rule-module"
      >
        <div class="title">{{ moduleInfo.title }}</div>
        <div
          v-for="(ruleInfo, ruleIndex) in moduleInfo.children"
          :key="ruleIndex"
          class="rule-item"
        >
          <div class="rule-title" v-html="ruleInfo.desc"></div>
          <div
            v-for="(subInfo, subIndex) in ruleInfo.children"
            :key="subIndex"
            class="sub-rule-item"
          >
            <div class="sub-rule-desc" v-html="subInfo"></div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import { API } from '@/api'
import { miniProgramEnv } from '@/defines/environment'
import { navBar } from '@/utils/native_interactions/native_bar'
import Url from '@mc/mc-utils/js/url/url'
export default {
  name: 'Rules',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.rules = []
      if (vm.isMiniProgram) {
        navBar.setTitle({
          text: '运费规则'
        })
      }
    })
  },
  data() {
    return {
      rules: [],
      isMiniProgram: miniProgramEnv.isMiniProgram,
      error: {
        show: false,
        msg: '未知错误。',
        subMsg: '未知错误。'
      },
      backPressed: window.backPressed
      // eslint-disable-next-line camelcase
      // listHeight: `${$_height - 0.88 * $_rem}px`
    }
  },
  mounted() {
    if (window.history.length) {
      window.backPressed = function () {
        window.history.go(-1)
      }
    }
  },
  destroyed() {
    window.backPressed = this.backPressed
  },
  created() {
    this.getFreightFeeRules()
  },
  methods: {
    goBack() {
      this.$back()
    },
    async getFreightFeeRules() {
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}

      // eslint-disable-next-line camelcase
      const selected_company_id =
        query.selected_company_id || hashQuery.selected_company_id || ''
      this.$Loading()
      try {
        const data = await API.shippingFee.getFreightFeeRules({
          selected_company_id
        })
        if (data.freight_rule_v1.length) {
          this.rules = data.freight_rule_v1 || []
        }
      } catch (error) {
        this.$catch(error)
      }
      this.$Loading.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;

  padding: 0 21px;

  background-color: #fff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  .rule-module {
    margin-top: 0.4rem;

    font-size: 0.28rem;
    color: #262626;
    &:last-child {
      padding-bottom: 10px;
    }

    .title {
      margin-bottom: 0.24rem;

      font-size: 0.32rem;
      font-weight: bold;
    }
    .rule-title,
    .sub-rule-desc {
      margin-bottom: 0.24rem;
    }
  }
}
</style>
